import React from "react";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";
import DefaultLayout from "components/layout/DefaultLayout";
import { color } from "styles/color";

const Wrapper = styled.div`
  background-color: ${color.primaryBlue};
  width: 100%;
  height: calc(100vh - 4.2rem);
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  @media (max-height: 375px) and (max-width: 812px) {
    height: 100%;
    padding: 3rem;
  }
`;
const MessageBox = styled.div`
  border: 1px solid white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  width: 80vw;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  margin-bottom: 8rem;
  @media (min-width: 768px) {
    width: 40vw;
    padding: 2rem;
    margin-bottom: 3rem;
  }
  h1,
  h2 {
    margin: 0;
    font-weight: 1000;
    font-size: 6rem;
    color: white;
  }
  h2 {
    font-size: 1rem;
    font-weight: 400;
  }
`;
const BackBtn = styled(Link)`
  border-radius: 1.5rem;
  padding: 1rem 2rem;
  min-width: 150px;
  max-width: 200px;
  background-color: white;
  color: ${color.markedSecondary};
  font-size: 1rem;
  text-align: center;
  text-decoration: none;
  transition: all 0.5s ease-out;
  &:hover {
    color: white;
    background-color: ${color.markedSecondary};
  }
`;

const NotFound = () => {
  return (
    <DefaultLayout>
      <Wrapper>
        <MessageBox>
          <h1>404</h1>
          <h2>网页不存在</h2>
          <h2>你要找的网页可能已被删除或网址输入错误</h2>
        </MessageBox>
        <BackBtn to="/">返回首页</BackBtn>
      </Wrapper>
    </DefaultLayout>
  );
};
export default NotFound;
